import axios from "axios";
import { STORE_BASE_URL } from "../BaseURL";
import getHeaders from "../../constants/headers";

export const getStorePartialBooking = (storeId) => {
    return axios({
        method: "get",
        url:
            STORE_BASE_URL +
            "/store/api/secure/v1/rider-partial-order/" +
            storeId,
        headers: getHeaders(),
    });
};

export const getPickupJobPartialOrder = (storeId, data) => {
    return axios({
        method: "post",
        url:
            STORE_BASE_URL +
            "/store/api/secure/v1/store/" +
            storeId + "/pickup-job-partial-order",
        headers: getHeaders(),
        data: JSON.stringify(data)
    });
};